import { DetailsPageTopControlsView } from "../common/panels/misc/DetailsPageTopControlsView/DetailsPageTopControlsView";
import { NotSet } from "../common/misc/UIconstants";
import Detail from "../common/panels/Detail/Detail";
import { Table } from "../common/panels/Detail/DetailTable";
import { EntityDetailProps, EntityDetailTableProps } from "../common/entity/EntityInterfaces";
import { DataFormatsTile } from "../common/sidebar/tiles/DataFormatsTile";
import { EntitySidebarTileAutosorter } from "../common/sidebar/tiles/EntitySidebarTile/EntitySidebarTileAutosorter";
import { CustomFieldReferencesTile } from "../common/sidebar/tiles/CustomFieldReferencesTile";
import { GenericEntityExportButton } from "../Entities/GenericComponents/common/GenericEntityExportButton";

export const MethodsDetailTable = ({ entity, entityConstants, fieldLabels }: EntityDetailTableProps<"methods">) => {
  return (
    <>
      <Table noPadding nonFoldable>
        <Table.Head>Details</Table.Head>
        <Table.Body>
          <Table.Body.RowContent
            title={fieldLabels.name}
            content={
              <div className="container_label">
                <div className="container_label_name" style={{ fontWeight: 600 }}>
                  {entity.name ?? NotSet}
                </div>
                <div className="container_label_id">
                  <span style={{ whiteSpace: "nowrap" }}>Method-ID: {entity.id}</span>
                </div>
              </div>
            }
          />

          <Table.Body.RowContent title={fieldLabels.fullName} content={entity.fullName} />

          <Table.Body.RowContent
            title={fieldLabels.description}
            content={
              <>
                {entity.description ? (
                  <div className="container_notes">
                    <textarea rows={4} className="container_textarea" value={entity?.description} disabled />
                  </div>
                ) : (
                  NotSet
                )}
              </>
            }
          />
        </Table.Body>
      </Table>
    </>
  );
};

export const MethodsDetail = ({
  permissions,
  routes,
  entity,
  entityApi,
  entityConstants,
  fieldLabels,
  entityTypeId,
}: EntityDetailProps<"methods">) => {
  return (
    <Detail
      head={
        <DetailsPageTopControlsView
          entityTypeId={entityTypeId}
          entity={entity}
          entityConstants={entityConstants}
          controlsDropdown={
            <>
              <li>
                <GenericEntityExportButton entity={entity as any} entityTypeId={entityTypeId} />
              </li>
            </>
          }
          hideHistoryModal
        />
      }
      mainStyle={{ padding: "0px 10px" }}
      main={
        <MethodsDetailTable
          entity={entity}
          entityConstants={entityConstants}
          fieldLabels={fieldLabels}
          entityTypeId={entityTypeId}
        />
      }
      sidebar={
        <EntitySidebarTileAutosorter>
          <DataFormatsTile
            defaultFilters={{ ids: entity.dataFormats.map((d) => d.id) }}
            excludeFilters={{ ids: () => false }}
          />
          <CustomFieldReferencesTile entityType="Method" entity={entity} />
        </EntitySidebarTileAutosorter>
      }
    />
  );
};
